import React from "react";
import { W, H, project } from "./constants";

const STARS = Array.from({ length: 100 }, (_, i) => {
  const seed = (i * 9301 + 49297) % 233280;
  return { id: `s-${i}`, x: seed % W, y: (seed * 7) % H, r: 0.5 + ((seed % 3) * 0.35) };
});
const MERIDIANS = Array.from({ length: 24 }, (_, i) => (i / 24) * W);
const PARALLELS = Array.from({ length: 12 }, (_, i) => (i / 12) * H);

export function MapDefs({ glow }) {
  return (
    <defs>
      <radialGradient id="mapBg" cx="50%" cy="55%" r="80%">
        <stop offset="0%" stopColor="#261E2E" stopOpacity="1" />
        <stop offset="55%" stopColor="#1C1622" stopOpacity="1" />
        <stop offset="100%" stopColor="#080013" stopOpacity="1" />
      </radialGradient>
      <linearGradient id="landFill" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stopColor="#6A4F78" stopOpacity="0.95" />
        <stop offset="45%" stopColor="#4A3356" stopOpacity="0.92" />
        <stop offset="100%" stopColor="#2b0058" stopOpacity="0.9" />
      </linearGradient>
      <linearGradient id="landShade" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stopColor="#8a3fdc" stopOpacity="0.15" />
        <stop offset="100%" stopColor="#000000" stopOpacity="0.15" />
      </linearGradient>
      <radialGradient id="pinGlow" cx="50%" cy="50%" r="50%">
        <stop offset="0%" stopColor={glow} stopOpacity="0.9" />
        <stop offset="60%" stopColor={glow} stopOpacity="0.25" />
        <stop offset="100%" stopColor={glow} stopOpacity="0" />
      </radialGradient>
      <filter id="softGlow">
        <feGaussianBlur stdDeviation="2.5" result="blur" />
        <feMerge><feMergeNode in="blur" /><feMergeNode in="SourceGraphic" /></feMerge>
      </filter>
      <filter id="landShadow" x="-5%" y="-5%" width="110%" height="110%">
        <feDropShadow dx="0" dy="1" stdDeviation="1.2" floodColor="#000000" floodOpacity="0.4" />
      </filter>
    </defs>
  );
}

export function MapBackground() {
  return (
    <>
      <rect x={0} y={0} width={W} height={H} fill="url(#mapBg)" />
      {MERIDIANS.map((x) => (
        <line key={`mer-${x}`} x1={x} y1={0} x2={x} y2={H} stroke="#4A3356" strokeOpacity="0.14" strokeWidth="0.4" vectorEffect="non-scaling-stroke" />
      ))}
      {PARALLELS.map((y) => (
        <line key={`par-${y}`} x1={0} y1={y} x2={W} y2={y} stroke="#4A3356" strokeOpacity="0.14" strokeWidth="0.4" vectorEffect="non-scaling-stroke" />
      ))}
      <line x1={0} y1={H/2} x2={W} y2={H/2} stroke="#C8A96E" strokeOpacity="0.15" strokeWidth="0.6" strokeDasharray="6 6" vectorEffect="non-scaling-stroke" />
      <line x1={0} y1={H*0.37} x2={W} y2={H*0.37} stroke="#C8A96E" strokeOpacity="0.08" strokeWidth="0.4" strokeDasharray="3 5" vectorEffect="non-scaling-stroke" />
      <line x1={0} y1={H*0.63} x2={W} y2={H*0.63} stroke="#C8A96E" strokeOpacity="0.08" strokeWidth="0.4" strokeDasharray="3 5" vectorEffect="non-scaling-stroke" />
      {STARS.map((s) => <circle key={s.id} cx={s.x} cy={s.y} r={s.r} fill="#ffffff" opacity={0.28} />)}
    </>
  );
}

export function AxisLabels() {
  return (
    <g fill="#C8A96E" fillOpacity="0.5" fontSize="8" fontFamily="'Courier Prime', monospace">
      {[-120, -60, 0, 60, 120].map((lg) => {
        const [x] = project(0, lg, W, H);
        return <text key={`lng-${lg}`} x={x + 3} y={H - 6}>{lg}°</text>;
      })}
      {[-60, -30, 0, 30, 60].map((la) => {
        const [, y] = project(la, 0, W, H);
        return <text key={`lat-${la}`} x={4} y={y - 3}>{la}°</text>;
      })}
    </g>
  );
}
